module.exports = __webpack_public_path__ + "static/media/gallery_14.ace11220.jpg";